import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-my-plans',
  templateUrl: './my-plans.component.html',
  styleUrls: ['./my-plans.component.scss']
})
export class MyPlansComponent implements OnInit {
  RetailerCommission: any;
  /* presentation only: which plan tab is showing */
  activePlan: string = 'aeps';

  constructor(private auth: AuthService,private ngxService: NgxUiLoaderService,private toastr: ToastrService, ) { }

  ngOnInit(): void {
    this.retailerCommission();
  }
  retailerCommission(){
    this.ngxService.start();
    this.auth.retailerCommissionApi().subscribe((res:any)=>{
      this.ngxService.stop();

      if(res.status_code == 1){
        this.RetailerCommission = res.object
        this.toastr.success(res.message);
      

      }else {
        this.RetailerCommission = [];

        this.toastr.error(res.error.message);

      }
    },err=>{
      this.ngxService.stop();

    })
  }
  handleTabChange(value){

  }

  // retailerCommission
}
